var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"centered":"","hide-footer":""}},[_vm._v("\r\n    Hello World!\r\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }